import { cn } from '@/shared/utils/utils';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-[11px] bg-muted', className)} {...props} />;
}

export { Skeleton };
